import React, { Component } from 'react';
import {
  Avatar,
  Card,
  CardActions,
  CardText,
  CardTitle,
  Grid,
  Cell,
} from 'react-md';

import './CategoryCard.scss';
import TrendReportModal from '../TrendReportModal/TrendReportModal';
import AttackInfoModal from '../AttackInfoModal/AttackInfoModal';

class CategoryCard extends Component {
  render() {
    const dataComplianceSection = [];
    dataComplianceSection.push(
      <Grid
        key={`${this.props.id}-A`}
        className="expanded-category-grid"
      >
        <Cell size={5} className="expanded-title-cell">
          <h2 className="expanded-left-title">Potential Data Leaked</h2>
        </Cell>
        <Cell size={2} />
        <Cell size={5} className="expanded-title-cell">
          <h2 className="expanded-right-title">Compliance Risks</h2>
        </Cell>
        <Cell size={12}>
          <hr className="horizontal-rule" />
        </Cell>
        <Cell size={5}>
          <h2 className="expanded-left-text">{this.props.dataLeakedA}</h2>
        </Cell>
        <Cell size={2}>
          <img className="expanded-icon" src={this.props.iconA} alt="" />
        </Cell>
        <Cell size={5}>
          <h2 className="expanded-right-text">{this.props.complianceA}</h2>
        </Cell>
      </Grid>,
    );

    if (this.props.dataLeakedB) {
      dataComplianceSection.push(
        <Grid key={`${this.props.id}-B`} className="expanded-category-grid">
          <Cell size={5}>
            <h2 className="expanded-left-text">{this.props.dataLeakedB}</h2>
          </Cell>
          <Cell size={2}>
            <img className="expanded-icon" src={this.props.iconB} alt="" />
          </Cell>
          <Cell size={5}>
            <h2 className="expanded-right-text">{this.props.complianceB}</h2>
          </Cell>
        </Grid>,
      );
    }

    return (
      <Card key={this.props.title} className="md-block-centered category-card">
        <CardTitle
          title=""
          avatar={<Avatar src={this.props.titleAvatar} role="presentation" />}
        >
          <h2 className="md-card-title--title md-text">{this.props.title}</h2>
          <AttackInfoModal
            id={this.props.id}
            title={this.props.title}
            whyText={this.props.whyText}
            riskText={this.props.riskText}
            riskScoreMalice={this.props.riskScoreMalice}
            riskScoreExposure={this.props.riskScoreExposure}
            riskScoreBreach={this.props.riskScoreBreach}
            className="modal-button"
          />
          <div className="alert-button-div">
            <TrendReportModal
              id={this.props.id}
              title={this.props.title}
              className="modal-button"
            />
          </div>
        </CardTitle>
        <CardActions expander>
          <Grid className="category-stats-grid">
            <Cell size={3} className="category-grid-cell zero-margin-cell">
              <h1 className="category-big-number category-grid-inside">
                {this.props.percentage}
              </h1>
            </Cell>
            <Cell
              size={7}
              className="category-grid-cell zero-margin-cell larger-prose-cell"
            >
              <h3 className="category-grid-inside category-prose">
                {this.props.prose}
              </h3>
            </Cell>
          </Grid>
        </CardActions>
        <CardText expandable>
          <Grid className="category-stats-grid">
            <Cell size={6} className="zero-margin-cell">
              <h1 className="category-count-number">
                {this.props.numTotalIncidents}
              </h1>
              <h1 className="category-count-text">total incidents</h1>
            </Cell>
            <Cell size={6} className="zero-margin-cell">
              <h1 className="category-count-number">
                {this.props.numMonthlyAvg}
              </h1>
              <h1 className="category-count-text">monthly average incidents</h1>
            </Cell>
            <Cell size={12}>
              <hr className="lighter-rule" />
            </Cell>
          </Grid>
          {dataComplianceSection}
        </CardText>
      </Card>
    );
  }
}

export default CategoryCard;



// WEBPACK FOOTER //
// ./src/components/CategoryCard/CategoryCard.jsx